import React from 'react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <div style={{maxWidth: '1000px', margin: '0 auto', padding: '2rem'}}>
      
      {/* Hero Section */}
      <div style={{background: 'white', borderRadius: '12px', padding: '3rem', marginBottom: '3rem', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', textAlign: 'center'}}>
        <h1 style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#2e7d32', marginBottom: '1rem'}}>
          Your Family History Journey Begins Here
        </h1>
        <h2 style={{fontSize: '1.5rem', color: '#8b4513', fontStyle: 'italic', marginBottom: '2rem'}}>
          Powered by GNology™
        </h2>
        <p style={{fontSize: '1.2rem', color: '#666', lineHeight: '1.8', marginBottom: '1.5rem'}}>
          Every family has a story worth preserving. Gene empowers you to uncover, understand, and beautifully document your family's unique legacy with the expertise of a <strong>Genealogical Research Assistant</strong> at your fingertips.
        </p>
        <p style={{fontSize: '1.1rem', color: '#555', lineHeight: '1.7', marginBottom: '2rem', maxWidth: '800px', margin: '0 auto 2rem auto'}}>
          Gene is powered by <strong style={{color: '#8b4513'}}>Generational Nexus (GNology)</strong> — a revolutionary genealogical knowledge framework that serves as the central connection point linking all family generations across time. This specialized system enables advanced family history research by creating powerful nexus points between past, present, and future family stories.
        </p>
      </div>

      {/* Value Proposition */}
      <div style={{background: '#faf6f1', borderRadius: '12px', padding: '2.5rem', marginBottom: '3rem'}}>
        <h2 style={{fontSize: '2rem', color: '#2e7d32', marginBottom: '2rem', textAlign: 'center'}}>
          Why Choose Gene for Your Family History?
        </h2>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '2rem'}}>
          <div style={{background: 'white', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #2e7d32'}}>
            <h3 style={{color: '#2e7d32', marginBottom: '1rem'}}>💰 Incredible Value</h3>
            <p style={{lineHeight: '1.6', color: '#555'}}>
              Professional genealogists charge <strong>$75-200+ per hour</strong> and complete family history books cost <strong>$15,000-50,000+</strong>. 
              Gene provides the same expert guidance for just <strong>$100/month</strong> — less than one hour with a professional genealogist.
            </p>
          </div>
          
          <div style={{background: 'white', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #8b4513'}}>
            <h3 style={{color: '#8b4513', marginBottom: '1rem'}}>🎓 Learn as You Discover</h3>
            <p style={{lineHeight: '1.6', color: '#555'}}>
              Unlike hired genealogists who do the work for you, Gene <strong>teaches you professional methodology</strong> while guiding your personal journey. 
              You gain the joy of discovery AND valuable skills for life.
            </p>
          </div>
          
          <div style={{background: 'white', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #2e7d32'}}>
            <h3 style={{color: '#2e7d32', marginBottom: '1rem'}}>📚 Complete Book Creation</h3>
            <p style={{lineHeight: '1.6', color: '#555'}}>
              From initial research to final narrative, Gene guides you through creating a <strong>meaningful family history book </strong> 
              that preserves your legacy for future generations — often in <strong>3 months or less</strong>.
            </p>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div style={{background: '#faf6f1', borderRadius: '12px', padding: '3rem', textAlign: 'center'}}>
        <h2 style={{fontSize: '2rem', color: '#2e7d32', marginBottom: '1.5rem'}}>
          Start Your Guided Family History Journey
        </h2>
        <p style={{fontSize: '1.2rem', color: '#666', marginBottom: '2rem', lineHeight: '1.7'}}>
          Your family's story deserves to be told with expertise, care, and love. 
          Let Gene help you preserve your legacy for generations to come.
        </p>
        <div style={{display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap'}}>
          <Link 
            to="/register" 
            style={{
              padding: '1rem 2rem', 
              background: '#2e7d32', 
              color: 'white', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '500'
            }}
          >
            Begin Your Journey
          </Link>
          <Link 
            to="/research" 
            style={{
              padding: '1rem 2rem', 
              border: '2px solid #2e7d32', 
              color: '#2e7d32', 
              borderRadius: '8px', 
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '500'
            }}
          >
            Explore Gene
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
